import { graphql } from "gql";

const ADMIN_EDIT_DISTRIBUTION_GROUP_MUTATION = graphql(`
  mutation AdminEditDistributionGroup(
    $id: ID!
    $input: AdminEditDistributionGroupInput!
  ) {
    adminEditDistributionGroup(id: $id, input: $input) {
      ...DistributionGroup
    }
  }
`);

export default ADMIN_EDIT_DISTRIBUTION_GROUP_MUTATION;
